import { getService } from 'reducers/service';
import ServiceName from '../constants/serviceName';
import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';
import axios from 'axios';

export const getAttachments = async ({ id, type, clearance }) => {
  const service = getService(ServiceName.rms_attachments);

  const response = await service.find({
    query: {
      id,
      type,
      clearance,
    },
  });

  return response?.data || response;
};

export const uploadAttachment = async (payload) => {
  const restClient = rest(window.__RUNTIME_CONFIG__.REACT_APP_API_URL);

  const app = feathers().configure(restClient.axios(axios));

  const token = window.localStorage.getItem('auth');

  const service = app.service(ServiceName.rms_attachments);

  const response = await service.create(payload, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      'Content-Type': 'multipart/form-data',
    },
  });

  return response?.data || response;
};
export const editAttachment = async (id, data) => {
  const service = getService(ServiceName.cad_attachments);
  const response = await service.patch(id, data);
  return response?.data || response;
};

export const deleteAttachment = async (id) => {
  const service = getService(ServiceName.cad_attachments);
  const response = await service.remove(id);
  return response?.data || response;
};

export const getAttachment = async (id) => {
  const service = getService(ServiceName.cad_attachments);
  const response = await service.get(id);
  return response;
};

export const getAttachmentById = async (id) => {
  const service = getService(ServiceName.rms_attachments);
  return service.get(id);
};
